export default __webpack_public_path__ + "static/media/InsideStomach_05.de37a0cc.png";